import { flattenNavAndFindBy } from 'utility/nav';

export const getReportFromNav = (navigation, predicate) => {
  if (navigation?.length) {
    return flattenNavAndFindBy(navigation, predicate);
  } else {
    return {};
  }
};
